export const content = {
  es: {
    nav: {
      home: "Inicio", historia: "Historia", ministerios: "Ministerios",
      sermones: "Sermones", eventos: "Eventos", contacto: "Contacto", donar: "Donar",
    },
    hero: {
      overline: "Kaufman, TX · Iglesia",
      titleA: "MOVIMIENTO",
      titleB: "CHURCH",
      sub: "Donde el Espíritu se mueve, hay vida.",
      verse: "“Espíritu, ven de los cuatro vientos, y sopla sobre estos muertos, y vivirán.”",
      verseRef: "Ezequiel 37:9-10",
      ctaPrimary: "Únete al movimiento",
      ctaSecondary: "Planea tu visita",
      badge: "Domingos 10:30 AM · Jueves 7:00 PM",
    },
    marquee: ["FE", "FAMILIA", "PROPÓSITO", "COMUNIDAD", "GRACIA", "MOVIMIENTO"],
    quienes: {
      overline: "Quiénes somos",
      title: "Una generación que no se queda quieta",
      text: "Somos una iglesia joven en Kaufman, Texas, donde la fe se vive en comunidad real: sin máscaras, sin religiosidad, sin frenos. Creemos que Dios sigue llamando — y que cada llamado puede convertirse en un movimiento que transforma una ciudad.",
      labels: ["Comunidad", "Adoración", "Discipulado"],
    },
    experiencia: {
      overline: "Experiencia y horarios",
      title: "Tu semana en Movimiento",
      cards: [
        { icon: "flame", title: "Servicios", text: "Adoración poderosa y un mensaje directo para tu semana.", time: "Domingos · 10:30 AM", link: "/eventos" },
        { icon: "users", title: "Grupos", text: "Grupos en casas para conocer gente real y crecer juntos.", time: "Durante la semana · Kaufman", link: "/ministerios" },
        { icon: "book", title: "Discipulado", text: "Fundamentos de la fe, paso a paso y a tu ritmo.", time: "Jueves · 7:00 PM", link: "/ministerios" },
        { icon: "calendar", title: "Eventos", text: "Noches de adoración, jóvenes y servicio a la ciudad.", time: "Cada mes · Ver agenda", link: "/eventos" },
      ],
    },
    testimonials: {
      overline: "Testimonios",
      title: "Historias que nos mueven",
      items: [
        { quote: "Llegué sin conocer a nadie y en un mes ya tenía familia. Mis hijos no quieren faltar ni un domingo.", name: "María G.", tag: "Familia Movimiento", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80" },
        { quote: "Encontré una fe real, sin religiosidad. Los mensajes me hablan directo a lo que vivo cada semana.", name: "Carlos R.", tag: "MVMT Jóvenes", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80" },
        { quote: "El desayuno comunitario me acercó, y la gente me hizo quedarme. Esta iglesia sirve de verdad a Kaufman.", name: "Ashley T.", tag: "Vecina de Kaufman", img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400&q=80" },
      ],
    },
    finalCta: {
      title: "Es momento de moverte",
      text: "No vengas a ver. Ven a ser parte. Este domingo hay un lugar con tu nombre.",
      cta: "Quiero ser parte del movimiento",
    },
    footer: {
      tagline: "Donde el Espíritu se mueve, hay vida. Kaufman, Texas.",
      address: "91 Oak Creek Dr, Kaufman, TX 75142",
      email: "info@movimientotx.com",
      services: "Dom 10:30 AM · Jue 7:00 PM",
      nav: "Explorar",
      contact: "Contacto",
      rights: "Movimiento Church. Todos los derechos reservados.",
    },
    historia: {
      overline: "Nuestra historia",
      title: "De una sala de estar a un movimiento",
      intro: "Movimiento Church nació en 2019 en la sala de una familia en Kaufman, con una convicción simple: la iglesia no es un edificio, es gente amando a Dios y a su ciudad.",
      timeline: [
        { year: "2019", title: "El comienzo", text: "Ocho personas, una sala de estar y un sueño: una iglesia bilingüe para Kaufman." },
        { year: "2021", title: "Primer local", text: "Abrimos las puertas de nuestro primer espacio y lanzamos Movimiento Kids." },
        { year: "2023", title: "MVMT Jóvenes", text: "Nace el ministerio de jóvenes y los servicios en inglés los domingos." },
        { year: "2026", title: "Hoy", text: "Una familia multicultural que sirve a Kaufman cada semana con fe y propósito." },
      ],
      beliefsOverline: "Nuestras creencias",
      beliefsTitle: "Lo esencial, sin complicaciones",
      beliefs: [
        { title: "La Biblia", text: "La Palabra de Dios: nuestra guía autoridad para creer y vivir." },
        { title: "Jesucristo", text: "El Hijo de Dios, que murió y resucitó para reconciliarnos con el Padre." },
        { title: "La Gracia", text: "La salvación es un regalo que se recibe por fe, no se gana por méritos." },
        { title: "El Espíritu Santo", text: "Dios presente y activo hoy, que nos llena, guía y transforma." },
        { title: "La Iglesia", text: "La familia de Dios llamada a amar, servir y hacer discípulos." },
        { title: "La Misión", text: "Llevar esperanza a Kaufman, a Texas y al mundo, con hechos y palabras." },
      ],
    },
    ministerios: {
      overline: "Ministerios",
      title: "Crecemos juntos, en cada etapa",
      sub: "Desde los más pequeños hasta las familias completas: hay un equipo y un lugar para ti.",
      items: [
        { key: "kids", title: "Movimiento Kids", age: "1 – 11 años", schedule: "Domingos · 10:30 AM", text: "Un ambiente seguro y divertido donde los niños aprenden de Jesús a su nivel, con juegos, arte y adoración." },
        { key: "jovenes", title: "MVMT Jóvenes", age: "12 – 18 años", schedule: "Viernes · 7:00 PM", text: "Noches de conexión, adoración y conversaciones honestas sobre la vida, la identidad y el propósito." },
        { key: "familias", title: "Familias y Matrimonios", age: "Todas las edades", schedule: "Jueves · 7:00 PM", text: "Estudios bíblicos, talleres y grupos en casas para fortalecer los cimientos de cada hogar." },
        { key: "adoracion", title: "Adoración y Producción", age: "Voluntarios", schedule: "Ensayos · Martes 7:00 PM", text: "Músicos, vocalistas y equipo técnico que crean los espacios de adoración de cada semana." },
        { key: "conexion", title: "Conexión y Café", age: "Voluntarios", schedule: "Domingos · 8:30 AM", text: "El primer abrazo que recibe cada visitante: bienvenida, café y acompañamiento para nuevas familias." },
      ],
      cta: "Quiero ser voluntario",
    },
    sermones: {
      overline: "Sermones",
      title: "Media Center",
      sub: "Revive los mensajes de cada domingo, en video y audio, donde estés.",
      liveTitle: "Transmisión en vivo",
      liveOffline: "Estamos fuera del aire",
      liveOfflineText: "Únete a la transmisión los domingos a las 10:30 AM (hora de Texas). Mientras tanto, explora los mensajes anteriores.",
      liveCta: "Agéndalo en tu calendario",
      play: "Ver mensaje",
      soon: "Video disponible muy pronto",
      soonText: "Estamos preparando la grabación de este mensaje. Vuelve a visitarnos en unos días.",
      filterAll: "Todos",
    },
    eventos: {
      overline: "Eventos",
      title: "Agenda de Movimiento",
      sub: "Servicios, noches de adoración y actividades comunitarias en Kaufman. Regístrate y aparta tu lugar.",
      register: "Registrarme",
      form: { name: "Nombre completo", email: "Correo electrónico", phone: "Teléfono (opcional)", guests: "Asistentes", submit: "Confirmar registro", sending: "Enviando…" },
      successTitle: "¡Registro listo!",
      mailNote: "Se abrirá tu app de correo con el registro listo para enviar a info@movimientotx.com",
      categories: { servicio: "Servicio", jovenes: "Jóvenes", familias: "Familias", adoracion: "Adoración", comunidad: "Comunidad" },
    },
    donar: {
      overline: "Donaciones",
      title: "Dar es parte de la misión",
      sub: "Tu generosidad sostiene los servicios, los ministerios y la obra comunitaria de Movimiento Church en Kaufman.",
      once: "Donación única",
      monthly: "Donación mensual",
      amounts: [10, 25, 50, 100],
      submit: "Continuar al pago seguro",
      comingSoon: "Las donaciones en línea estarán disponibles muy pronto / Online giving coming soon.",
      secure: "Pago procesado de forma segura por Stripe. Movimiento Church no almacena los datos de tu tarjeta.",
      impactTitle: "Tu donación en acción",
      impact: [
        { title: "Servicios dominicales", text: "Equipos, producción y espacios de adoración cada semana." },
        { title: "Movimiento Kids y Jóvenes", text: "Materiales, seguridad y experiencias para la próxima generación." },
        { title: "Kaufman", text: "Desayunos comunitarios y apoyo directo a familias de nuestra ciudad." },
      ],
    },
    payment: {
      successTitle: "¡Gracias por tu generosidad!",
      successText: "Tu donación fue procesada con éxito. Recibirás el recibo de Stripe en tu correo.",
      pending: "Confirmando tu pago…",
      cancelTitle: "Donación cancelada",
      cancelText: "No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.",
      back: "Volver al inicio",
      retry: "Intentar de nuevo",
    },
    contacto: {
      overline: "Contacto y ubicación",
      title: "Hablemos",
      sub: "¿Preguntas, oración o quieres planificar tu primera visita? Escríbenos.",
      addressLabel: "Dirección",
      hoursLabel: "Horarios",
      emailLabel: "Correo",
      form: { name: "Nombre completo", email: "Correo electrónico", phone: "Teléfono (opcional)", message: "Tu mensaje", submit: "Enviar mensaje", sending: "Enviando…" },
      successTitle: "¡Mensaje listo!",
      mailNote: "Se abrirá tu app de correo con el mensaje listo para enviar a info@movimientotx.com",
    },
    common: { loading: "Cargando…" },
  },

  en: {
    nav: {
      home: "Home", historia: "Our Story", ministerios: "Ministries",
      sermones: "Sermons", eventos: "Events", contacto: "Contact", donar: "Give",
    },
    hero: {
      overline: "Kaufman, TX · Church",
      titleA: "MOVIMIENTO",
      titleB: "CHURCH",
      sub: "Where the Spirit moves, there is life.",
      verse: "“Come, breath, from the four winds and breathe into these slain, that they may live.”",
      verseRef: "Ezekiel 37:9-10",
      ctaPrimary: "Join the movement",
      ctaSecondary: "Plan your visit",
      badge: "Sundays 10:30 AM · Thursdays 7:00 PM",
    },
    marquee: ["FAITH", "FAMILY", "PURPOSE", "COMMUNITY", "GRACE", "MOVEMENT"],
    quienes: {
      overline: "Who we are",
      title: "A generation that won't sit still",
      text: "We are a young church in Kaufman, Texas, where faith is lived in real community: no masks, no religiosity, no brakes. We believe God is still calling — and every calling can become a movement that transforms a city.",
      labels: ["Community", "Worship", "Discipleship"],
    },
    experiencia: {
      overline: "Experience & times",
      title: "Your week at Movimiento",
      cards: [
        { icon: "flame", title: "Services", text: "Powerful worship and a straight-to-your-week message.", time: "Sundays · 10:30 AM", link: "/eventos" },
        { icon: "users", title: "Groups", text: "Home groups to meet real people and grow together.", time: "Throughout the week · Kaufman", link: "/ministerios" },
        { icon: "book", title: "Discipleship", text: "Foundations of faith, step by step, at your pace.", time: "Thursdays · 7:00 PM", link: "/ministerios" },
        { icon: "calendar", title: "Events", text: "Worship nights, youth gatherings and city outreach.", time: "Every month · See calendar", link: "/eventos" },
      ],
    },
    testimonials: {
      overline: "Testimonies",
      title: "Stories that move us",
      items: [
        { quote: "I arrived knowing no one, and within a month I had a family. My kids never want to miss a Sunday.", name: "María G.", tag: "Movimiento family", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=400&q=80" },
        { quote: "I found a real faith, without religiosity. The messages speak straight into what I live every week.", name: "Carlos R.", tag: "MVMT Youth", img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&q=80" },
        { quote: "The community breakfast drew me in, and the people made me stay. This church truly serves Kaufman.", name: "Ashley T.", tag: "Kaufman neighbor", img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=400&q=80" },
      ],
    },
    finalCta: {
      title: "It's time to move",
      text: "Don't come to watch. Come to belong. This Sunday there's a seat with your name on it.",
      cta: "I want to be part of the movement",
    },
    footer: {
      tagline: "Where the Spirit moves, there is life. Kaufman, Texas.",
      address: "91 Oak Creek Dr, Kaufman, TX 75142",
      email: "info@movimientotx.com",
      services: "Sun 10:30 AM · Thu 7:00 PM",
      nav: "Explore",
      contact: "Contact",
      rights: "Movimiento Church. All rights reserved.",
    },
    historia: {
      overline: "Our story",
      title: "From a living room to a movement",
      intro: "Movimiento Church was born in 2019 in a family's living room in Kaufman, with one simple conviction: the church is not a building — it's people loving God and their city.",
      timeline: [
        { year: "2019", title: "The beginning", text: "Eight people, one living room and a dream: a bilingual church for Kaufman." },
        { year: "2021", title: "First location", text: "We opened the doors of our first space and launched Movimiento Kids." },
        { year: "2023", title: "MVMT Youth", text: "The youth ministry is born, along with English services on Sundays." },
        { year: "2026", title: "Today", text: "A multicultural family serving Kaufman every week with faith and purpose." },
      ],
      beliefsOverline: "Our beliefs",
      beliefsTitle: "The essentials, made simple",
      beliefs: [
        { title: "The Bible", text: "God's Word: our trusted guide for what we believe and how we live." },
        { title: "Jesus Christ", text: "The Son of God, who died and rose again to reconcile us to the Father." },
        { title: "Grace", text: "Salvation is a gift received by faith, not earned by merit." },
        { title: "The Holy Spirit", text: "God present and active today, who fills, guides and transforms us." },
        { title: "The Church", text: "God's family, called to love, serve and make disciples." },
        { title: "The Mission", text: "Bringing hope to Kaufman, to Texas and to the world, in word and deed." },
      ],
    },
    ministerios: {
      overline: "Ministries",
      title: "We grow together, in every season",
      sub: "From the littlest ones to entire families: there's a team and a place for you.",
      items: [
        { key: "kids", title: "Movimiento Kids", age: "Ages 1 – 11", schedule: "Sundays · 10:30 AM", text: "A safe, fun environment where kids learn about Jesus at their level — with games, art and worship." },
        { key: "jovenes", title: "MVMT Youth", age: "Ages 12 – 18", schedule: "Fridays · 7:00 PM", text: "Connection nights, worship and honest conversations about life, identity and purpose." },
        { key: "familias", title: "Families & Marriages", age: "All ages", schedule: "Thursdays · 7:00 PM", text: "Bible studies, workshops and home groups to strengthen the foundations of every household." },
        { key: "adoracion", title: "Worship & Production", age: "Volunteers", schedule: "Rehearsals · Tuesdays 7:00 PM", text: "Musicians, vocalists and the tech team creating each week's worship experience." },
        { key: "conexion", title: "Connection & Coffee", age: "Volunteers", schedule: "Sundays · 8:30 AM", text: "The first hug every guest receives: welcome, coffee and guidance for new families." },
      ],
      cta: "I want to volunteer",
    },
    sermones: {
      overline: "Sermons",
      title: "Media Center",
      sub: "Re-watch Sunday's messages, on video and audio, wherever you are.",
      liveTitle: "Live stream",
      liveOffline: "We're offline",
      liveOfflineText: "Join the live stream on Sundays at 10:30 AM (Texas time). In the meantime, browse past messages.",
      liveCta: "Save it to your calendar",
      play: "Watch message",
      soon: "Video coming soon",
      soonText: "We're preparing this message's recording. Check back in a few days.",
      filterAll: "All",
    },
    eventos: {
      overline: "Events",
      title: "The Movimiento calendar",
      sub: "Services, worship nights and community gatherings in Kaufman. Register and save your spot.",
      register: "Register",
      form: { name: "Full name", email: "Email address", phone: "Phone (optional)", guests: "Guests", submit: "Confirm registration", sending: "Sending…" },
      successTitle: "Registration ready!",
      mailNote: "Your email app will open with the registration ready to send to info@movimientotx.com",
      categories: { servicio: "Service", jovenes: "Youth", familias: "Families", adoracion: "Worship", comunidad: "Community" },
    },
    donar: {
      overline: "Giving",
      title: "Giving is part of the mission",
      sub: "Your generosity sustains the services, ministries and community work of Movimiento Church in Kaufman.",
      once: "One-time gift",
      monthly: "Monthly gift",
      amounts: [10, 25, 50, 100],
      submit: "Continue to secure checkout",
      comingSoon: "Las donaciones en línea estarán disponibles muy pronto / Online giving coming soon.",
      secure: "Payment securely processed by Stripe. Movimiento Church never stores your card details.",
      impactTitle: "Your gift in action",
      impact: [
        { title: "Sunday services", text: "Teams, production and worship spaces every single week." },
        { title: "Movimiento Kids & Youth", text: "Materials, safety and experiences for the next generation." },
        { title: "Kaufman", text: "Community breakfasts and direct support for families in our city." },
      ],
    },
    payment: {
      successTitle: "Thank you for your generosity!",
      successText: "Your gift was processed successfully. You'll receive a Stripe receipt by email.",
      pending: "Confirming your payment…",
      cancelTitle: "Donation canceled",
      cancelText: "No charge was made. You can try again anytime.",
      back: "Back to home",
      retry: "Try again",
    },
    contacto: {
      overline: "Contact & location",
      title: "Let's talk",
      sub: "Questions, prayer, or planning your first visit? Write to us.",
      addressLabel: "Address",
      hoursLabel: "Service times",
      emailLabel: "Email",
      form: { name: "Full name", email: "Email address", phone: "Phone (optional)", message: "Your message", submit: "Send message", sending: "Sending…" },
      successTitle: "Message ready!",
      mailNote: "Your email app will open with the message ready to send to info@movimientotx.com",
    },
    common: { loading: "Loading…" },
  },
};
